define([
	"dojo/_base/declare",
	"BusinessPlanning/BusinessCategoryFilterController"
], function(declare,BusinessCategoryFilterController) {

	return declare(BusinessCategoryFilterController,{

		/**
		 * @override
		 * Gets FilterType attr for query search from Category (BusinessCategory) node
		 */
		_getFilterType: function() {
			var category = this.m_cache.getNode(this.getNode().Category);
			return category.FilterType;
		}
	});

});
